import {createAction} from '@reduxjs/toolkit';

import * as notificationActions from './notifications.js';
import workerErrors from '../worker/errors.js';
import {selectFilteredResultsList} from '../selectors/results.js';

const PREFIX = 'results';

export const resetResults = createAction(`${PREFIX}/reset`);
export const resultsCompleted = createAction(`${PREFIX}/completed`);
export const updateStatus = createAction(`${PREFIX}/updateStatus`);

export const addResultToOrder = createAction(`${PREFIX}/addToOrder`);
export const addResultToView = createAction(`${PREFIX}/addToView`);

export const removeResultFromOrder = createAction(`${PREFIX}/removeFromOrder`);
export const removeAllFromOrder = createAction(`${PREFIX}/removeAllFromOrder`);
export const removeResultFromView = createAction(`${PREFIX}/removeFromView`);
export const removeAllFromView = createAction(`${PREFIX}/removeAllFromView`);

export const addItemsToOrder = createAction(`${PREFIX}/addItemsToOrder`);
export const addItemsToView = createAction(`${PREFIX}/addItemsToView`);

export const removeItemsFromOrder = createAction(
  `${PREFIX}/removeItemsFromOrder`
);
export const removeItemsFromView = createAction(
  `${PREFIX}/removeItemsFromView`
);

// support shift + click
export const selectResults = createAction(`${PREFIX}/selectMany`);

// Keep for Shift + Click support in OG UX
export const selectMulti = payload => (dispatch, getState) => {
  const state = getState();
  const {resultsById, viewResults} = state.results;
  const resultsList = selectFilteredResultsList(state);
  // right now viewResults & orderResults have the same info
  const selectedResultsTimestamps = viewResults.map(
    r => resultsById[r].properties.acquired
  );
  const selectTimestamps = [
    ...selectedResultsTimestamps,
    payload.result.properties.acquired,
  ];
  selectTimestamps.sort();
  const firstTimestamp = selectTimestamps[0];
  const lastTimestamp = selectTimestamps[selectTimestamps.length - 1];

  const newResults = resultsList.filter(
    result =>
      result.properties.acquired >= firstTimestamp &&
      result.properties.acquired <= lastTimestamp &&
      !viewResults.includes(result.id)
  );
  dispatch(selectResults({resultIds: newResults.map(nr => nr.id)}));
};

export const handleResults = createAction(`${PREFIX}/handleWorkerResults`);

export const handleWorkerMessage = eventData => dispatch => {
  const {type, data} = eventData;

  if (data && !data.more) {
    dispatch(resultsCompleted());
  }

  if (type === 'add') {
    dispatch(updateStatus(data.loading));
    dispatch(handleResults(data.results));
  } else if (type === 'error') {
    if (data.code === workerErrors.INVALID_GEOMETRY) {
      dispatch(
        notificationActions.notify({
          title: {i18nKey: 'searchInput.errorInvalidGeometryTitle'},
          persist: true,
          message: {i18nKey: 'searchInput.errorInvalidGeometryMessage'},
        })
      );
    } else if (data.code === workerErrors.INVALID_FIELD) {
      dispatch(
        notificationActions.notify({
          title: {i18nKey: 'searchInput.errorInvalidFilterTitle'},
          persist: true,
          message: data.messages[0] || {
            i18nKey: 'searchInput.errorInvalidFilterMessage',
          },
          severity: 'error',
        })
      );
    } else {
      dispatch(
        notificationActions.notify({
          title: {i18nKey: 'searchInput.errorUnexpectedResponseTitle'},
          message: data.messages || {
            i18nKey: 'searchInput.errorUnexpectedResponseMessage',
          },
          persist: true,
        })
      );
    }

    dispatch(updateStatus(false));
  }
};
